export default (params) => ({
  trigger: {
    name: 'product_trade_in.click_on_calculate_value',
    params: params,
  },
  config: {
    schema: {
      content: {
        enum: [
          'trade_in_tool',
          'offer',
        ],
      },
      sub_feature: {
        enum: [
          'not_recognized',
          'recognized',
          'other',
        ],
      },
    },
    event: {
      name: 'select_content',
    },
  },
});
